import * as amplitude from '@amplitude/unified';

import runtimeEnv from '~/shared/utils/runtimeEnv';

let initialized = false;

/**
 * Initializes Amplitude analytics and Session Replay.
 *
 * The API key arrives through `window.__RUNTIME_ENV__` (see
 * `public/__RUNTIME_ENV__.js` for local dev and the per-stage
 * `<STAGE>_AMPLITUDE_API_KEY` secret applied by the deploy workflow), so each
 * environment reports into its own project and can be rotated without a
 * rebuild. An environment with no key configured — currently everything but
 * development and production — intentionally sends nothing.
 *
 * Safe to call more than once — only the first call initializes the SDK.
 */
export function initAmplitude(): void {
  if (initialized) return;

  const apiKey = runtimeEnv.amplitudeApiKey;
  if (!apiKey) {
    console.info(
      'Amplitude analytics disabled — no API key for this environment'
    );
    return;
  }

  initialized = true;

  amplitude.initAll(apiKey, {
    analytics: { autocapture: true },
    sessionReplay: { sampleRate: 1 },
  });
}

export { amplitude };
